// extracted by mini-css-extract-plugin
export default {"root":"MultiLineCellStub_root__cfVFj","placeHolderShimmer":"MultiLineCellStub_placeHolderShimmer__1kg6i"};